import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
import { heroContent } from '../data/mock';

const HeroSection = () => {
  return (
    <section className="hero-section" id="home">
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="hero-badge"
        >
          <Zap size={16} />
          <span>{heroContent.announcement}</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="heading-hero mb-6"
        >
          Artificial Intelligence
          <br />
          <span className="gradient-text">Strategy & Solutions</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="body-large mb-10 max-w-2xl mx-auto"
        >
          {heroContent.subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <a href="#contact" className="btn-primary">
            {heroContent.cta}
            <ArrowRight size={18} />
          </a>
          <a href="#services" className="btn-secondary">
            {heroContent.secondaryCta}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-20 pt-8"
          style={{ borderTop: '1px solid var(--border-light)' }}
        >
          <p className="caption mb-6">Trusted by innovators worldwide</p>
          <div className="flex flex-wrap justify-center gap-8 items-center">
            <span className="text-sm" style={{ color: 'var(--text-muted)' }}>Tech Startups</span>
            <span style={{ color: 'var(--border-primary)' }}>•</span>
            <span className="text-sm" style={{ color: 'var(--text-muted)' }}>Enterprises</span>
            <span style={{ color: 'var(--border-primary)' }}>•</span>
            <span className="text-sm" style={{ color: 'var(--text-muted)' }}>Entrepreneurs</span>
            <span style={{ color: 'var(--border-primary)' }}>•</span>
            <span className="text-sm" style={{ color: 'var(--text-muted)' }}>Innovators</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
